import {wdiCore} from '@/components/WdiControls';
import {formatter, request} from './request';
import {Enum} from "@/enums/system";

const download = async (url: string, option: any, name?: string) => {
  if (url.indexOf("http") > -1) {
    const a = document.createElement('a');
    a.href = url;
    if (name) {
      a.download = name;
    }

    a.target = '_blank';
    a.click();
    URL.revokeObjectURL(url);

  } else {
    option['responseType'] = 'blob';
    option['getResponse'] = true;

    return await request(url, option).then((response) => {
      const url = URL.createObjectURL(response.data);
      const filename = response.response.headers.get('ajax-name') || name || `Export_${wdiCore.Date.ToString(new Date())}.xlsx`;
      const a = document.createElement('a');
      a.href = url;
      try {
        a.download = window.decodeURIComponent(filename);
      } catch {
        a.download = filename;
      }
      a.target = '_blank';
      a.click();
      URL.revokeObjectURL(url);
    });
  }
};

const downLoadBlob = async (url:string)=>{
  const option = formatter({method: 'GET'});
  option['responseType'] = 'blob';
  option['getResponse'] = true;
  const blobRes = await request(url, option);
  return blobRes?.data;
}

export function formatFileDownload(file: any) {
  return formatFileToUrl(file, '/fileapi/file/download');
}

export function formatFileToUrl(file: any, urlPrefix: string) {
  let url = `${urlPrefix}?name=${window.encodeURIComponent(file.name)}`;
  if (file.url) {
    if (file.url.indexOf("http") > -1) {
      url = file.url;
    } else if (String(file.url).length <= 15 && /^[0-9]*$/g.test(String(file.url))) {
      url += '&id=' + file.url;
    } else {
      url += '&path=' + window.encodeURIComponent(file.url);
    }
  }
  return url;
}

export async function fileDownload(file: any) {
  const url = formatFileDownload(file);
  return await download(url, formatter({method: 'GET'}), file.name);
}

export async function fileDownloadBlob(file: any) {
  const url = formatFileDownload(file);
  return await downLoadBlob(url);
}

export async function fileDownloadBase64(file: any) {
  const blob = await fileDownloadBlob(file);
  return await blobToBase64(blob)
}

const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export function getFileContent(file: any) {
  const url = formatFileDownload(file);
  let options = formatter({method: 'GET', responseType: 'text'});
  return request(url, options)
}

export async function fileObjectURL(url: string) {
  const option: Record<string, any> = {};
  option['method'] = 'GET';
  option['responseType'] = 'blob';
  option['getResponse'] = true;
  const response = await request(url, option);
  return URL.createObjectURL(response.data);
}

const fileSuffixMap = new Map<Enum.FileType, string[]>([
  [Enum.FileType.IMG, ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff']],
  [Enum.FileType.WORD, ['doc', 'docx', 'dot', 'wps', 'wpt', 'dotx', 'docm', 'dotm', 'rtf']],
  [Enum.FileType.PPT, ['ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps']],
  [Enum.FileType.EXCEL, ['et', 'xls', 'xlt', 'xlsx', 'xlsm', 'xltx', 'xltm', 'csv']],
  [Enum.FileType.PDF, ['pdf']],
  [Enum.FileType.TXT, ['txt','sql','xml','md','json','log']],
])

export function isAnImage(fnExtension?: string) {
  return Enum.FileType.IMG == getFileType(fnExtension);
}

export const getFileType = (fileName?: string) => {
  let fileType = Enum.FileType.NONE;
  if (!fileName) {
    return fileType;
  }
  const lowerCaseFileName = fileName.toLowerCase();
  for (const [k, v] of fileSuffixMap) {
    if (v.some(suffix => lowerCaseFileName.endsWith('.' + suffix))) {
      fileType = k;
      break;
    }
  }
  return fileType;
}

export default download;
